// Клиент представлений: описание уходит на сервер, обратно приходят данные.
//
// Описание не исполняется на клиенте ни в каком виде. Всё, что здесь есть, —
// это отправить его и получить ответ, уже разобранный и ограниченный правами.
import { apiDelete, apiGet, apiPatch, apiPost } from '../../../shared/api-client/index.js';
import type { ViewResult } from '../../../views/result.js';
import type { ViewSpec } from '../../../views/spec.js';

export function runViewSpec(spec: ViewSpec): Promise<ViewResult> {
  return apiPost<ViewResult, ViewSpec>('/views/query', spec);
}

export interface ViewSpecIssue {
  path: string;
  message: string;
  hint?: string;
}

export interface ViewsAgentTurn {
  reply: string;
  /** `fixtures` — пока за llm-gate нет модели; `gate` — настоящий вызов. */
  mode: 'fixtures' | 'gate';
  spec?: ViewSpec;
  result?: ViewResult;
  issues?: ViewSpecIssue[];
  savedViewId?: string;
}

export function askViewsAgent(prompt: string): Promise<ViewsAgentTurn> {
  return apiPost<ViewsAgentTurn, { prompt: string }>('/views/agent', { prompt });
}

export interface SavedView {
  id: string;
  title: string;
  spec: ViewSpec;
  inSidebar: boolean;
  onDashboard: boolean;
  position: number;
  sharedToAll: boolean;
  sharedWithMemberIds: string[];
  ownerMemberId: string;
  ownerName: string;
  /** Своё представление или пришедшее по доступу — от этого зависит, можно ли править. */
  own: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface SaveViewPayload {
  title: string;
  spec: ViewSpec;
  inSidebar?: boolean;
  onDashboard?: boolean;
  sharedToAll?: boolean;
  sharedWithMemberIds?: string[];
}

export function listSavedViews(): Promise<SavedView[]> {
  return apiGet<SavedView[]>('/views/saved');
}

export function createSavedView(payload: SaveViewPayload): Promise<SavedView> {
  return apiPost<SavedView, SaveViewPayload>('/views/saved', payload);
}

export function updateSavedView(id: string, payload: Partial<SaveViewPayload>): Promise<SavedView> {
  return apiPatch<SavedView, Partial<SaveViewPayload>>(`/views/saved/${id}`, payload);
}

export function deleteSavedView(id: string): Promise<void> {
  return apiDelete<void>(`/views/saved/${id}`);
}

/** Данные закреплённого представления — исполняется правами того, кто смотрит. */
export function fetchSavedViewData(id: string): Promise<ViewResult> {
  return apiGet<ViewResult>(`/views/saved/${id}/data`);
}
